import { render, staticRenderFns } from "./FilesViewModal.vue?vue&type=template&id=3121cf8c"
import script from "./FilesViewModal.vue?vue&type=script&lang=js"
export * from "./FilesViewModal.vue?vue&type=script&lang=js"
import style0 from "./FilesViewModal.vue?vue&type=style&index=0&id=3121cf8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports